<template>
  <v-form ref="sendEmailForm">
    <v-row>
      <v-col cols="12">
        <v-select
            class="pt-0"
            v-model="type"
            :items="types"
            item-text="text"
            item-value="value"
            label="Typ"
            :rules="rules.type"
            aria-required="true"
        ></v-select>
      </v-col>
      <v-col cols="12"
             v-if="type === 'templated'"
      >
        <v-select
            class="pt-0"
            v-model="template"
            :items="templates"
            item-text="subject"
            item-value="id"
            label="Szablon"
            :rules="rules.template"
        >
          <template v-slot:item="data">
            <span class="flex">
              {{ data.item.subject }}
            </span>
            <small>
              {{ data.item.id }}
            </small>
          </template>
          <template v-slot:selection="data">
            <span>
              {{ data.item.subject }}
              <small>
                ({{ data.item.id }})
              </small>
            </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="pt-0"
            v-model="subject"
            placeholder="Tytuł wiadomości"
            :rules="rules.subject"
            hint="Zostaw puste jeśli chcesz wysłać z domyślnym tytułem."
            persistent-hint
            counter
        ></v-text-field>
      </v-col>
      <v-col cols="12"
             v-if="type === 'custom'"
      >
        <v-textarea
            class="pt-0"
            v-model="html"
            placeholder="Treść wiadomości (HTML)"
            :rules="rules.html"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn
            color="primary"
            block
            @click="send"
            :disabled="disabled || (!templates && 'templated' === type)"
        >
          Wyślij
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import api from "@/services/api";

export default {
  props: {
    // Id of Company, SaleOffer, User or any other entity the user id can be retrieved from.
    receiverEntityId: [Number, String],

    // Name of the Doctrine entity, without namespace.
    receiverEntityName: String,

    /**
     * List of Twig email templates ids that should be included in the response.
     * @see \App\Enum\EmailTemplate::ALL in API project.
     * */
    templatesToList: [Array, String],

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    clearOnSend: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
  },
  data() {
    return {
      types: [
        {value: 'templated', text: 'Z szablonu'},
        {value: 'custom', text: 'Ręcznie komponowana'},
      ],
      templates: [],
      type: null,
      template: null,
      subject: null,
      html: null,
      rules: {
        type: [
          (value) => !!value || 'Wybierz typ wiadomości.',
        ],
        template: [
          (value) => ('custom' === this.type || !!value) || 'Wybierz szablon.',
        ],
        subject: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 10 || 'Tytuł powinien mieć conajmniej 10 znaków.'
          },
        ],
        html: [
          (value) => ('templated' === this.type || !!value) || 'Wpisz treść wiadomości.',
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getTemplates();
    this.$props.clearOnSend = (false !== this.$props.clearOnSend && '1' !== this.$props.clearOnSend);
  },
  methods: {
    clearIfRequested() {
      if (this.$props.clearOnSend) {
        this.clear();
      }
    },
    clear() {
      this.type = null;
      this.template = null;
      this.subject = null;
      this.html = null;
    },
    getTemplates() {
      let params = {};

      if (this.$props.templatesToList) {
        params.templates = this.$props.templatesToList instanceof String
            ? Array.of(this.$props.templatesToList)
            : this.$props.templatesToList;
      }

      api.get('/api/email/templates', {params})
          .then((response) => {
            this.templates = response.data.templates;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać listy dostępnych szablonów e-mail.',
              error,
            });
          });
    },
    send() {
      if (!this.$refs.sendEmailForm.validate()) {
        return;
      }

      let url, data = {
        entityId: this.receiverEntityId || null,
        entityName: this.receiverEntityName || '',
      };

      if ('templated' === this.type) {
        url = '/api/email/send-templated';
        data.subject = null !== this.subject ? String(this.subject).trim() : '';
        data.template = this.template;
      } else {
        url = '/api/email/send-custom';
        data.subject = null !== this.subject ? String(this.subject).trim() : '';
        data.html = String(this.html).trim();
      }

      api.post(url, data)
          .then((response) => {
            if (202 === response.status) {
              this.$root.$emit('notifySuccess', {
                html: 'Serwer potwierdził przyjęcie wiadomości do wysłania.',
              });
              this.clearIfRequested();

              return;
            }

            this.$root.$emit('notifyError', {
              html:
                  `Serwer zwrócił inny kod odpowiedzi (${response.status}) HTTP niż oczekiwany (202). ` +
                  'Wiadomość mogła nie zostać wysłana.',
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wysłać wiadomości.',
              error,
            });
          });
    },
  }
};
</script>